// Module
var code = "<template>\r\n  <div slot=\"content\">\r\n    <h1>${message}</h1>\r\n\r\n    <div id=\"map\" style=\"width: 100%; height: 400px;\"></div>\r\n  </div>\r\n</template>\r\n";
// Exports
export default code;